import firebase from "./firebase/firebase";
import { useAsync } from "react-async";

export function isValidEmail(email) {
  return !!email.match(/\S+@\S+\.\S+/); //(/.+@.+/);
}

export function sum(a, b) {
  return a + b;
}

export function log(msg) {
  console.log(msg);
}

export function getUserMessages(username) {
  const fs = firebase.firestore();
  //const checking = await
  let posts = [];

  fs.collection("Posts")
    .doc(username)
    .collection("Messages")
    .get()
    .then((doc) => {
      doc.forEach((d) => {
        posts.push({ keyid: d.id, ...d.data() });
      });

      if (posts.length === 0) {
        // console.log(" not found data")
      } else {
        const data = {
          messages: posts,
          error: false,
          errorMsg: "",
        };
        return data;
      }
    })
    .catch((error) => {
      const data = {
        messages: [],
        error: true,
        errorMsg: "unable to pull posts from server, due to connection error",
      };
      return data;
    });
}
